/* ThroatClear — página de producto v2: versiones, precio, galería y barra fija */
(function () {
  if (window.__tcpLoaded) return;
  window.__tcpLoaded = true;

  function money(cents, format) {
    var parts = (cents / 100).toFixed(2).split('.');
    var eu = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return format && format.indexOf('{{') > -1 ? format.replace(/\{\{\s*\w+\s*\}\}/, eu) : eu + ' €';
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-tcp-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var dots = root.querySelectorAll('[data-tcp-dot]');
    var thumbs = root.querySelectorAll('[data-tcp-thumb]');
    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    function go(i, smooth) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, slides[0].offsetWidth + 10));
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) i = slides.length - 1;
        mark(Math.min(slides.length - 1, i));
        ticking = false;
      });
    }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var cur = function () { var a = root.querySelector('[data-tcp-thumb].is-active, [data-tcp-dot].is-active'); return a ? Array.prototype.indexOf.call(a.parentNode.children, a) : 0; };
    var prev = root.querySelector('[data-tcp-prev]'), next = root.querySelector('[data-tcp-next]');
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, cur() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, cur() + 1)); });
    return {
      toMedia: function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
        }
      }
    };
  }

  function initBuyBox() {
    var root = document.querySelector('[data-tcp]');
    if (!root || root.dataset.tcpBound) return;
    root.dataset.tcpBound = '1';
    var fmt = root.getAttribute('data-money-format');
    var form = document.getElementById('tc-form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-tcp-price]');
    var compareEl = root.querySelector('[data-tcp-compare]');
    var saveEl = root.querySelector('[data-tcp-save]');
    var addBtn = root.querySelector('[data-tcp-add]');
    var addLabel = root.querySelector('[data-tcp-add-label]');
    var buyNow = root.querySelector('[data-tcp-buynow]');
    var sticky = document.querySelector('[data-tcp-sticky]');
    var stickyPrice = sticky ? sticky.querySelector('[data-tcp-sticky-price]') : null;
    var stickyBtn = sticky ? sticky.querySelector('button') : null;
    var car = initCarousel(root);
    var opts = root.querySelectorAll('[data-tcp-variant]');
    var hint = root.querySelector('[data-tcp-hint]');

    function select(input, fromUser) {
      opts.forEach(function (o) { var l = o.closest('.tcp-seg__opt, .tcp-opt'); if (l) l.classList.toggle('is-checked', o === input); });
      if (hint) hint.textContent = input.getAttribute('data-desc') || '';
      var d = input.dataset;
      var price = parseInt(d.price, 10), compare = parseInt(d.compare || '0', 10), available = d.available === 'true';
      if (idInput) idInput.value = input.value;
      // Precio ya formateado por Shopify en la moneda del país del cliente (si existe)
      var priceTxt = d.priceFmt || money(price, fmt);
      if (priceEl) priceEl.textContent = priceTxt;
      var btnPrice = root.querySelector('[data-tcp-btn-price]');
      if (btnPrice) btnPrice.textContent = ' · ' + priceTxt;
      if (stickyPrice) stickyPrice.textContent = input.getAttribute('data-title') + ' · ' + priceTxt;
      if (compareEl) {
        var has = compare > price;
        compareEl.hidden = !has;
        if (has) compareEl.textContent = money(compare, fmt);
        if (saveEl) {
          saveEl.hidden = !has;
          if (has) saveEl.textContent = saveEl.getAttribute('data-prefix') + ' ' + money(compare - price, fmt);
        }
      }
      [addBtn, buyNow, stickyBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addLabel) addLabel.textContent = available ? addLabel.getAttribute('data-add') : addLabel.getAttribute('data-sold');
      // Al cargar se queda en la 1ª imagen (infografías); solo salta a la foto de la versión si el cliente la elige
      if (car && d.media && fromUser) car.toMedia(d.media);
      // La URL solo cambia cuando el cliente elige otra versión (por defecto queda limpia)
      if (fromUser) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }
    opts.forEach(function (o) { o.addEventListener('change', function () { select(o, true); }); });
    var checked = root.querySelector('[data-tcp-variant]:checked');
    if (checked) select(checked, false);

    var qty = root.querySelector('[data-tcp-qty]');
    if (qty) {
      var q = qty.querySelector('input');
      qty.querySelector('[data-minus]').addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
      qty.querySelector('[data-plus]').addEventListener('click', function () { q.value = (parseInt(q.value, 10) || 1) + 1; });
    }

    // Barra fija: aparece cuando el botón principal ya ha quedado por encima de la pantalla
    // y se oculta mientras se ve otro punto de compra (para no duplicar botones).
    if (sticky && addBtn) {
      var hideZones = Array.prototype.slice.call(document.querySelectorAll('[data-tcp-hide-sticky]'));
      var pending = false;
      var refresh = function () {
        pending = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var aboveMain = addBtn.getBoundingClientRect().bottom < 0;
        var zoneVisible = hideZones.some(function (z) {
          var r = z.getBoundingClientRect();
          return r.top < vh * 0.85 && r.bottom > vh * 0.15;
        });
        sticky.classList.toggle('is-visible', aboveMain && !zoneVisible);
      };
      var onScroll = function () { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      refresh();
    }
  }

  function init() { initBuyBox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { window.__tcpLoaded = true; init(); });
})();

/* One cart mutation per click; rendering failures never submit the product again. */
(function tcpAddToDrawer() {
  if (window.__tcpDrawerLoaded) return;
  window.__tcpDrawerLoaded = true;
  var pending = false;
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  function json(response) {
    return response.json().then(function (data) {
      if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || 'No se pudo actualizar el carrito.');
      return data;
    });
  }
  function message(form, text, checkout) {
    var box = form.querySelector('[data-tcp-cart-message]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-tcp-cart-message', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = text;
    if (checkout) {
      var button = document.createElement('button');
      button.type = 'submit'; button.name = 'checkout';
      button.textContent = document.documentElement.lang.indexOf('es') === 0 ? 'Ir al pago seguro' : 'Checkout';
      button.setAttribute('formaction', cartUrl);
      button.setAttribute('data-tcp-checkout-fallback', '');
      box.appendChild(button);
    }
  }
  function bind() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    document.querySelectorAll('main form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.tcpDrawer) return;
      form.dataset.tcpDrawer = '1';
      form.addEventListener('submit', async function (event) {
        if (event.submitter && event.submitter.hasAttribute('data-tcp-checkout-fallback')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending) return;
        pending = true;
        var buttons = form.id === 'tc-form' ? document.querySelectorAll('[data-tcp-add], [form="tc-form"]') : form.querySelectorAll('[type="submit"]');
        var oldMessage = form.querySelector('[data-tcp-cart-message]');
        if (oldMessage) oldMessage.remove();
        var data = new FormData(form);
        buttons.forEach(function (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; });
        var added = false;
        try {
          var sections = drawer.getSectionsToRender().map(function (section) { return section.id; });
          data.set('sections', sections.join(','));
          data.set('sections_url', window.location.pathname);
          var cart = await fetch(cartUrl + '.js').then(json);
          var handle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
          var updates = {};
          cart.items.forEach(function (item) { if (item.handle === handle) updates[item.key] = 0; });
          if (Object.keys(updates).length) {
            await fetch(cartUrl + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(json);
          }
          var addUrl = (window.routes && window.routes.cart_add_url) || cartUrl + '/add';
          var result = await fetch(addUrl.replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: data }).then(json);
          added = true;
          drawer.setActiveElement(event.submitter || document.activeElement);
          try {
            drawer.renderContents(result);
          } catch (renderError) {
            // GET-only recovery: the product has already been added successfully.
            var rendered = await fetch(cartUrl + '?sections=' + sections.join(',')).then(json);
            drawer.renderContents({ sections: rendered });
          }
        } catch (error) {
          console.error('GetCravel cart:', error);
          message(form, added ? 'El producto está en tu carrito. Puedes continuar al pago aquí.' : error.message, added);
        } finally {
          pending = false;
          buttons.forEach(function (button) { button.removeAttribute('aria-busy'); button.disabled = false; });
        }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  window.addEventListener('load', bind);
})();


/* Vídeo inicial de la galería: forzar reproducción en silencio (algunos navegadores ignoran autoplay) */
(function tcpGalleryVideo() {
  function go() {
    document.querySelectorAll('.tcp-car__slide--video video').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  window.addEventListener('load', go);
  document.addEventListener('touchstart', go, { once: true, passive: true });
})();

/* Regalo con candado: abierto solo con el pack configurado (data-pos = posición del pack) */
(function tcpGift() {
  function sync() {
    document.querySelectorAll('[data-tcp-gift]').forEach(function (g) {
      var form = g.closest('form') || document;
      var opts = Array.prototype.slice.call(form.querySelectorAll('[data-tcp-variant]'));
      if (!opts.length) opts = Array.prototype.slice.call(document.querySelectorAll('[data-tcp-variant]'));
      var idx = opts.findIndex(function (o) { return o.checked; }) + 1;
      var open = idx === parseInt(g.dataset.pos || '3', 10);
      g.classList.toggle('is-open', open);
      var inp = g.querySelector('[data-tcp-gift-input]'); if (inp) inp.disabled = !open;
    });
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-tcp-variant]')) sync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();

